import React from "react"
import { Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import { CloseButton } from "../../internationalization/LocaleFormatted"

export default function OfflineFileLogModal({ data, show, onHide }) {
  const sample_data = {
    file_path: data.file_path,
    sample_id: data.sample_id,
    sample_source_type: data.sample_source_type,
    method_name: data.method_name,
    sampling_time: data.sampling_time,
    test_items: data.test_items,
  }
  const log_data = {
    log_status: data.log_status,
    log_message: data.log_message,
    log_detail: data.log_detail,
  }
  const DisplayBlock = ({ id, defaultMsg, d }) => {
    return (
      <>
        <h5>
          <FormattedMessage id={id} defaultMessage={defaultMsg} />:
        </h5>
        <pre className={"prism-code-pre"}>
          <code>{JSON.stringify(d, null, 4)}</code>
        </pre>
      </>
    )
  }
  return (
    <Modal
      size={"lg"}
      dialogClassName={"common-modal"}
      show={show}
      onHide={onHide}
      style={{ overflowX: "scroll", overflowY: "scroll" }}
      backdrop={"static"}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <>
            <div>
              <FormattedMessage id={"samplemanagement.sample.id"} />
              :&nbsp;{data.sample_id}
            </div>
            <div style={{ fontSize: "80%" }}>
              <FormattedMessage id={"general.file"} />
              :&nbsp;{data.file_path}
            </div>
          </>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DisplayBlock id={"general.file"} defaultMsg={"File"} d={sample_data} />
        <DisplayBlock id={"general.log"} defaultMsg={"Logs"} d={log_data} />
      </Modal.Body>
      <Modal.Footer>
        <CloseButton onClose={onHide} />
      </Modal.Footer>
    </Modal>
  )
}
